import { Loading, LoadingProps } from '@risk-first/ui-loading';
import { FC } from 'react';

export const LoadingSpinner: FC<LoadingProps> = (props) => <Loading data-testid="loading-spinner" {...props} />;
